import { useEffect } from 'react';

import { getLocation } from '@web-platform/shared-universal-redux/src/state';
import { getVirtualReferrerFromLocationState } from '@web-platform/shared-universal-utils-frontend/src/helpers/getLocationState';
import { logError } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

export const useUpdateVirtualReferrer = () => {
  const stateLocation = useSelector(getLocation);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const { virtualReferrer } = stateLocation;
      const storedVirtualReferrer = getVirtualReferrerFromLocationState(location);

      if (virtualReferrer.length > 0 && storedVirtualReferrer !== virtualReferrer) {
        const updatedState = { ...location.state, virtualReferrer };

        navigate(location, { state: updatedState, replace: true });
      }
    } catch (err) {
      logError({
        component: 'useUpdateVirtualReferrer',
        message: 'unable to update history state with virtual referrer',
        error: err,
        stack: err && err.stack,
      });
    }
  }, [location, navigate, stateLocation]);
};
